export const tenantKeys = {
  all: ['tenant'] as const,
  detail: (id: string): readonly unknown[] => [...tenantKeys.all, id] as const,
};
